import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Main = styled.span`
  font: ${props => props.theme.fontWeightBold} 10px/120% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  color: white;
  margin-bottom: 2px;

  & > strong {
    font-size: 19px;
    margin-right: 4px;
  }
`;

const singular = w => ({ enquiries: 'enquiry' }[w] || w.slice(0, -1));

export default function TypedUnitTooltip({ payload }) {
  const [{ value, name }] = payload;

  return (
    <Main>
      <strong>{value}</strong>
      {value === 1 ? singular(name) : name}
    </Main>
  );
}

TypedUnitTooltip.propTypes = {
  payload: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
};
